import * as React from 'react'

import loadable from '@loadable/component'

import * as Data from '../data'

import { Iframe } from './iframe'

const SolidPlayngoLauncher = loadable(() => import('./solid-playngo-launcher'))
const BingoLauncher = loadable(() => import('./bingo-launcher'))
const PlayNGoLauncher = loadable(() => import('./play-n-go-launcher'))
const PushGamingLauncher = loadable(() => import('./push-gaming-launcher'))

export function IframeLauncher() {
  const game = Data.useGame()
  if (game.provider === 'solidgaming' && game.displayProvider === 'playngo') {
    return <SolidPlayngoLauncher />
  }

  if (
    game.provider === 'evoplay' &&
    game.displayProvider === 'evoplay' &&
    game.launchUrl.includes('bingo')
  ) {
    return <BingoLauncher />
  }

  if (game.provider === 'playngo') {
    return <PlayNGoLauncher />
  }

  if (game.provider === 'pushgamingdirect') {
    return <PushGamingLauncher />
  }

  if (game.provider === 'evolution') {
    return (
      <Iframe allow="geolocation *; bluetooth *; accelerometer *; gyroscope *; fullscreen *" />
    )
  }

  return <Iframe />
}

// for @loadable/components
export default IframeLauncher
